import { render } from "./PublicNavLinks.vue?vue&type=template&id=2aa0cffe&scoped=true"
import script from "./PublicNavLinks.vue?vue&type=script&lang=js"
export * from "./PublicNavLinks.vue?vue&type=script&lang=js"

import "./PublicNavLinks.vue?vue&type=style&index=0&id=2aa0cffe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2aa0cffe"]])

export default __exports__